import { homeAtom } from "@/atoms/home.ts";
import NewsList from "./NewsList";
import Paging from "./Paging/index.tsx";

export default function NewsDefault() {
  const { pathname } = useLocation();
  const fetchNewsData = useSetAtom(homeAtom);
  useEffect(() => {
    fetchNewsData(pathname);
  }, []);

  return (
    <div className="bg-[var(--app-bg-01)]">
      <NewsList />
      <Paging />
    </div>
  );
}
